import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError } from 'rxjs/operators';
import { DynamicField, FormDataDto, ServiceSelectionDto } from 'src/app/services/dtos';
import { DynamicInputField } from 'src/app/services/enum';
import { HttpSubmissionService } from 'src/app/services/http-submission.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilService } from 'src/app/services/util.service';

class DynamicFieldWithImage {
	field: DynamicField;
	image: any;
}

class DynamicJson {
	id: number;
	f: string;
}

@Component({
  selector: 'app-display-selfreg-card',
  templateUrl: './display-selfreg-card.component.html',
  styleUrls: ['./display-selfreg-card.component.scss']
})
export class DisplaySelfRegCardComponent {

	@Input() userRef: string;
	@Input() pin: string;
	@Input() axonId: number;
	@Input() textFields: DynamicField[];
	@Input() qrData: string;
	@Input() image: any;
	@Input() qrImage: any;

	constructor(private translateService: TranslateService, public util: UtilService){}

	getQrData(): string {
		return this.axonId + ':' + this.qrData;
	}

}
